import { render, staticRenderFns } from "./PayPalKeys.vue?vue&type=template&id=311682c8&scoped=true&lang=pug&"
import script from "./PayPalKeys.vue?vue&type=script&lang=js&"
export * from "./PayPalKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311682c8",
  null
  
)

/* custom blocks */
import block0 from "./PayPalKeys.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports